import VolatilityConesContent from './volatility-cones-content';
import { Widget } from '../../widget';
import TokenSelector from '../../token-selector';
import Source from '../../source';
import { useContext } from 'react';
import { IVolatilityConesProps } from './types';
import WidgetButtons from '../../widget-buttons';
import { WidgetContext } from '../../widget-renderer/widget-provider';

const VolatilityConesWidget = (props: IVolatilityConesProps) => {
  const { widget, actions } = props;

  const { hasDefaultToken, token, setToken } = useContext(WidgetContext);

  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title={widget.title} />
        <Widget.HeaderPanel>
          <TokenSelector token={token} setToken={setToken} isFixedToken={hasDefaultToken} />
        </Widget.HeaderPanel>
        <Widget.Buttons>
          <WidgetButtons widget={widget} actions={actions} permissions={props.permissions} />
        </Widget.Buttons>
      </Widget.Header>
      <Widget.Content>
        <VolatilityConesContent providerKey={props.providerKey} />
      </Widget.Content>
      <Widget.Footer>
        <Source source="Deribit" url="https://www.deribit.com" />
      </Widget.Footer>
    </Widget>
  );
};

export default VolatilityConesWidget;
